// extracted by mini-css-extract-plugin
export var content = "index-module--content--0eeed";
export var link = "index-module--link--c4b0d";
export var linkText = "index-module--linkText--415e1";
export var price = "index-module--price--effcb";
export var root = "index-module--root--c58cc";
export var subContent = "index-module--subContent--b6313";
export var title = "index-module--title--49124";